import { render } from "./SmartDashboard.vue?vue&type=template&id=134a18ce&scoped=true"
import script from "./SmartDashboard.vue?vue&type=script&lang=js"
export * from "./SmartDashboard.vue?vue&type=script&lang=js"

import "./SmartDashboard.vue?vue&type=style&index=0&id=134a18ce&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134a18ce"]])

export default __exports__